enum ChatType {
    Group = 'Group',
    Private = 'Private',
}

export default ChatType;